<template>
  <div class="width-height-percent" :id="id" :ref="id"></div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  data () {
    return {
      qrcode: ''
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },
    text: { // 后端返回的二维码地址
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '128'
    },
    height: {
      type: String,
      default: '128'
    },
    colorDark: {
      type: String,
      default: '#000000'
    },
    colorLight: {
      type: String,
      default: '#ffffff'
    },
    image: {
      type: String,
      default: ''
    }
  },
  watch: {
    text (newText) {
      this.createQrcode()
    }
  },
  mounted () {
    this.createQrcode()
  },
  methods: {
    createQrcode () {
      if (this.qrcode) { // 有新的二维码地址了，先把之前的清除掉
        this.$refs[this.id].innerHTML = ''
      }
      this.qrcode = new QRCode(this.$refs[this.id], {
        text: this.text, // 页面地址 ,如果页面需要参数传递请注意哈希模式#
        width: this.width, // 二维码宽度 （不支持100%）
        height: this.height, // 二维码高度 （不支持100%）
        colorDark: this.colorDark,
        colorLight: this.colorLight,
        correctLevel: 3
        // correctLevel: QRCode.CorrectLevel.H
      })
      if (this.image) {
        const logo = new Image();
        logo.crossOrigin = 'Anonymous';
        logo.src = this.image// 填入你本地log图片
        // 生成log图
        logo.onload = () => {
          const qrImg = this.qrcode._el.getElementsByTagName('img')[0]; // 获取二维码
          const canvas = this.qrcode._el.getElementsByTagName('canvas')[0]; // 获取canvas

          const ctx = canvas.getContext("2d");
          ctx.drawImage(logo, 150 * 0.5 - 22, 150 * 0.5 - 22, 44, 44); // 写入log
          qrImg.src = canvas.toDataURL();
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.width-height-percent{
  width: 100%;
  height: 100%;
}
</style>
